// Tiny markdown subset for assistant prose: code fences, inline code, bold,
// italic, line breaks. No external library. Used only for the streaming chat
// transcript — rich-rendered Markdown content from envelopes goes through the
// vendored @viz/widgets Markdown widget instead.

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, c => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c] as string
  ));
}

export function renderMarkdownLite(s: string): string {
  return escapeHtml(s)
    // text-slate-100 explicitly — the chat panel has dark text on a light
    // background, so without an override the code text inherits dark color
    // and disappears against the dark slate-800/900 code block (Bug: chat
    // code blocks black-on-black, 2026-05-20).
    .replace(/```(\w*)\n([\s\S]*?)```/g, (_m, _lang, body) => `<pre class="overflow-x-auto rounded bg-slate-900 p-2 text-xs text-slate-100"><code class="text-slate-100">${body}</code></pre>`)
    .replace(/`([^`]+)`/g, "<code class=\"rounded bg-slate-800 px-1 py-px font-mono text-xs text-slate-100\">$1</code>")
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
    .replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, "<em>$1</em>")
    .replace(/\n/g, "<br/>");
}
